import KtrlLayout from "../../components/ktrl/KtrlLayout";

const Tag = ({ children }) => (
  <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-600 mb-3">
    {children}
  </span>
);

const engagementModel = [
  {
    icon: "🧑‍💻",
    title: "Vi jobber i deres kodebase, ikke ved siden av den",
    text: "Ingen powerpoint-strategi levert på avstand. Vi kobler oss på deres faktiske systemer, data og verktøy, og bygger direkte i det dere allerede har — fordi det er der verdien faktisk oppstår.",
  },
  {
    icon: "⚡",
    title: "Rask iterasjon, tidlig i produksjon",
    text: "Første fungerende versjon på dager, ikke måneder. Vi tester mot ekte arbeidsoppgaver fra uke én, og justerer kursen basert på hva som faktisk fungerer — ikke hva som så bra ut i et møte.",
  },
  {
    icon: "🤝",
    title: "Vi blir til det er ferdig — ikke til rapporten er levert",
    text: "Et forward deployed engineering-team sitter tett på til løsningen faktisk kjører i produksjon og leverer verdi, ikke bare til en prototype er demonstrert.",
  },
  {
    icon: "📚",
    title: "Kompetansen blir igjen hos dere",
    text: "Målet er ikke varig avhengighet av oss. Vi dokumenterer, overfører eierskap og bygger opp intern kapasitet underveis, slik at dere kan drifte og videreutvikle selv når vi trapper ned.",
  },
];

const engagementTypes = [
  {
    title: "Embedded engineering",
    text: "Én eller flere av våre folk jobber som en del av deres team — daglig kontakt, samme verktøy, samme Slack-kanaler. Best egnet når dere skal bygge noe som skal leve videre internt.",
  },
  {
    title: "Definerte prosjekter",
    text: "Et konkret problem, en klar leveranse, en tidsramme. Vi tar ansvar for hele løpet fra teknisk design til produksjonssetting.",
  },
  {
    title: "Rådgivning og second opinion",
    text: "Dere har allerede teknisk kapasitet, men trenger noen med erfaring fra AI-systemer i produksjon å sparre med — på arkitektur, verktøyvalg eller hvorfor noe ikke fungerer som forventet.",
  },
];

const KtrlTjenesterPage = () => {
  return (
    <KtrlLayout>
      <section className="max-w-5xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <Tag>Tjenester</Tag>
        <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-slate-900 mb-6 max-w-2xl">
          AI-konsulentvirksomhet, forward deployed
        </h1>
        <p className="text-lg text-slate-600 leading-relaxed max-w-2xl mb-16">
          Vi sender ikke over en rapport og forsvinner. Vi kobler oss på deres team og deres
          systemer, bygger det som faktisk trengs, og blir til det virker i produksjon — enten det
          er ett enkelt verktøy eller en gjennomgående AI-drevet arbeidsflyt.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {engagementModel.map((item) => (
            <div key={item.title} className="border border-slate-200 rounded-xl p-6">
              <div className="text-2xl mb-3">{item.icon}</div>
              <h3 className="font-bold text-lg text-slate-900 mb-3">{item.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        <Tag>Hvordan vi jobber sammen</Tag>
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900 mb-6 max-w-2xl">
          Tre måter å engasjere oss på
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {engagementTypes.map((t) => (
            <div key={t.title} className="bg-slate-50 border border-slate-200 rounded-xl p-6">
              <h3 className="font-semibold text-slate-900 mb-3">{t.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{t.text}</p>
            </div>
          ))}
        </div>

        <div className="border border-slate-200 rounded-xl p-6 mb-16 flex items-start gap-4">
          <span className="text-2xl">🇪🇺</span>
          <div>
            <h4 className="font-semibold text-slate-900 mb-1">Sikkerhet og personvern i bunnen</h4>
            <p className="text-sm text-slate-600 leading-relaxed">
              Alt vi bygger tilpasses det sikkerhetsnivået og den grad av separasjon deres
              organisasjon krever, og settes opp i tråd med GDPR og personvern — uansett om dere
              driver med finans, helse eller noe helt annet.
            </p>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-16 text-center">
          <p className="text-indigo-600 text-sm font-semibold uppercase tracking-widest mb-2">
            Klar for neste steg?
          </p>
          <h2 className="text-2xl font-bold text-slate-900 mb-4">Ta kontakt</h2>
          <p className="text-slate-600 mb-6 max-w-lg mx-auto">
            Fortell oss om problemet dere prøver å løse — vi hjelper dere med å finne ut hva slags
            engasjement som passer, uten forpliktelser.
          </p>
          <div className="flex items-center justify-center gap-2 text-slate-700">
            <a href="tel:+4790639637" className="font-medium hover:text-indigo-600 transition-colors">
              +47 906 39 637
            </a>
            <span className="text-slate-300">·</span>
            <a
              href="mailto:jakob@ktrl.no"
              className="font-medium hover:text-indigo-600 transition-colors"
            >
              jakob@ktrl.no
            </a>
          </div>
        </div>
      </section>
    </KtrlLayout>
  );
};

export default KtrlTjenesterPage;
